import { checkConsent, consentCategories } from 'utils/cookies';

import {
  sentryClient,
  sentryKey,
  sentryProject,
  version,
  sentryRegex,
} from 'utils/settings';

const sentryEnabled = (): boolean =>
  Boolean(
    window.ikea.sentry &&
      sentryKey &&
      sentryProject &&
      sentryClient &&
      version &&
      checkConsent(consentCategories.performanceCookies)
  );

const release = `igift-agent@${version}`;

export const sentryInit = () => {
  if (sentryEnabled()) {
    window.ikea.sentry.register(
      sentryProject,
      sentryKey,
      sentryClient,
      release,
      1, // Log 100% of errors for now
      [sentryRegex]
    );
  } else {
    console.warn('[igift] Sentry is not active');
  }
};

export const reportError = (e: Error | string) => {
  if (sentryEnabled()) {
    window.ikea.sentry.store(
      e,
      sentryProject,
      sentryKey,
      sentryClient,
      release,
      1
    );
  }
  console.error('[igift]', e);
};
